<template>
<div>
    <client-average-payment-duration-invoice-list ref="clientAveragePaymentDurationInvoiceList"></client-average-payment-duration-invoice-list>
    <!-- Filter Form -->
    <b-row class="align-items-center">
        <b-col class="col-lg-5 mt-2">
            <b-form-group>
                <div class="d-flex align-items-center">
                    <label class="mr-2">{{ $t('clientAveragePaymentDurationReport.agent') }}</label>
                    <v-select id="agent" v-model="agentSelect" :options="agentOption" @input="setClientId" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @search="onSearch">
                    </v-select>
                </div>
            </b-form-group>
        </b-col>
        <b-col class="col-lg-2 mt-2">
            <b-form-group>
                <div class="d-flex align-items-center">
                    <label class="mr-2">{{ $t('clientAveragePaymentDurationReport.start_date') }}</label>
                    <b-form-input v-model="filters.startDate" type="date" size="sm" class="d-inline-block" :min="minStartDate" @change="validateStartDate" />
                </div>
            </b-form-group>
        </b-col>
        <b-col class="col-lg-2 mt-2">
            <b-form-group>
                <div class="d-flex align-items-center">
                    <label class="mr-2">{{ $t('clientAveragePaymentDurationReport.end_date') }}</label>
                    <b-form-input v-model="filters.endDate" type="date" size="sm" class="d-inline-block" />
                </div>
            </b-form-group>
        </b-col>
        <b-col class="d-flex justify-content-end col-lg-3 mt-2">
            <b-form-group>
                <div class="d-flex align-items-center">
                    <b-button size="sm" variant="outline-primary" @click="getClientAveragePaymentDurationReport()">{{ $t('others.list') }}</b-button>
                    <b-button style="margin-left: 0.5em;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                </div>
            </b-form-group>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="clientAveragePaymentDurationReportTable" ref="clientAveragePaymentDurationReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
            enabled: true,
            externalQuery: searchTerm
        }" :pagination-options="{
            enabled: true,
            perPage: pageLength
        }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>

        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'clientName'" class="text-nowrap">
                {{ $t('clientAveragePaymentDurationReport.client_name') }}
            </span>
            <span v-else-if="props.column.field === 'currency'" class="text-nowrap">
                {{ $t('clientAveragePaymentDurationReport.currency') }}
            </span>
            <span v-else-if="props.column.field === 'invoiceCount'" class="text-nowrap">
                {{ $t('clientAveragePaymentDurationReport.invoice_count') }}
            </span>
            <span v-else-if="props.column.field === 'totalPaymentDuration'" class="text-nowrap">
                {{ $t('clientAveragePaymentDurationReport.total_payment_duration') }}
            </span>
            <span v-else-if="props.column.field === 'averagePaymentDuration'" class="text-nowrap">
                {{ $t('clientAveragePaymentDurationReport.average_payment_duration') }}
            </span>
        </template>

        <!-- Column: Table Row Data -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'clientName'">
                <span style="cursor: pointer; font-weight: bold; color: blue;" @click="showClientInvoiceList(props.row)">{{ props.row.clientName }}</span>
                <br>
                <span style="font-size: smaller;">{{ props.row.clientAccountingNo }}</span>
            </span>
            <span v-else-if="props.column.field === 'totalPaymentDuration'">
                {{ parseFloat(props.row.totalPaymentDuration).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}
            </span>
            <span v-else-if="props.column.field === 'averagePaymentDuration'">
                {{ parseFloat(props.row.averagePaymentDuration).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}
                    </span>
                    <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1" @input="onPageLengthChange" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getClientAveragePaymentDurationReport()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        clientAccountingId: Number,
    },
    data() {
        return {
            pageLength: 10,
            pageNo: 1,
            total: 0,
            searchTerm: '',
            agentSelect: 0,
            agentOption: [],
            selectedClientAccountingId: 0,
            minStartDate: '2015-01-01',
            filters: {
                startDate: '2015-01-01',
                endDate: null,
            },
            columns: [{
                    label: this.$t('clientAveragePaymentDurationReport.client_name'),
                    field: 'clientName',

                },
                {
                    label: this.$t('clientAveragePaymentDurationReport.currency'),
                    field: 'currency',
                },
                {
                    label: this.$t('clientAveragePaymentDurationReport.invoice_count'),
                    field: 'invoiceCount',
                },
                {
                    label: this.$t('clientAveragePaymentDurationReport.total_payment_duration'),
                    field: 'totalPaymentDuration',
                },
                {
                    label: this.$t('clientAveragePaymentDurationReport.average_payment_duration'),
                    field: 'averagePaymentDuration',
                },
            ],
            rows: [],
            excelRows: [],
        }
    },
    mounted() {},
    methods: {
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetClientAccountingByClientName',
                    forAgentOrInvoice: 1,
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.agentOption = response.data.clientList
                    loading(false)
                })
            }
        },
        setClientId(event) {
            this.selectedClientAccountingId = event ? event.clientAccountingId : 0
        },
        validateStartDate() {
            if (this.filters.startDate && this.filters.startDate < this.minStartDate) {
                this.$WarningAlert(this.$t('alerts.date_cannot_be_before_2015'))
                this.filters.startDate = this.minStartDate
            }
        },
        showClientInvoiceList(row) {
            const startDate = this.filters.startDate ? new Date(this.filters.startDate) : null
            const endDate = this.filters.endDate ? new Date(this.filters.endDate) : null
            this.$refs.clientAveragePaymentDurationInvoiceList.getClientInvoiceListForAveragePaymentDurationReport(row.clientAccountingId, row.clientName, startDate, endDate)
        },
        onPageLengthChange() {
            this.pageNo = 1
            this.getClientAveragePaymentDurationReport()
        },
        getClientAveragePaymentDurationReport() {
            this.rows = []
            const controller = {
                name: 'Report',
                actionName: 'GetClientAveragePaymentDurationReport'
            }
            const data = {
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                startDate: this.filters.startDate ? new Date(this.filters.startDate) : null,
                endDate: this.filters.endDate ? new Date(this.filters.endDate) : null,
                clientAccountingId: this.clientAccountingId || this.selectedClientAccountingId || 0,
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.total = response.data.total
                    this.rows = response.data.clientAveragePaymentDurationReportList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        exportExcel() {
            this.excelRows = []
            const controller = {
                name: 'Report',
                actionName: 'GetClientAveragePaymentDurationReport'
            }
            const data = {
                pageLength: this.total,
                pageNo: 1,
                startDate: this.filters.startDate ? new Date(this.filters.startDate) : null,
                endDate: this.filters.endDate ? new Date(this.filters.endDate) : null,
                clientAccountingId: this.clientAccountingId || this.selectedClientAccountingId || 0,
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.excelRows = response.data.clientAveragePaymentDurationReportList
                    const controller = {
                        name: 'Invoice',
                        actionName: 'CanExport'
                    }
                    const data = {
                        columnList: this.columns,
                        dataList: this.excelRows
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$downloadFile(this.$t('Client Average Payment Duration Report'), response.data.base64, 'xlsx')
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })

        }
    }
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}

.agentInput {
    max-width: 87em !important;
    width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}
</style>
